export type DocumentSource =
  | 'shared-with'
  | 'shared-by'
  | 'report'
  | 'loa'
  | 'export'
  | 'internal';

export const SOURCE_BADGE_CONFIG: Record<
  DocumentSource,
  { label: string; className: string }
> = {
  'shared-with': {
    label: 'Praetorian',
    className: 'bg-chariot-brand-tertiary text-chariot-brand-primary',
  },
  'shared-by': {
    label: 'Customer',
    className: 'bg-chariot-status-warning/10 text-chariot-status-warning',
  },
  report: {
    label: 'Report',
    className:
      'bg-chariot-stroke-light-green/10 text-chariot-stroke-light-green',
  },
  loa: {
    label: 'LOA',
    className: 'bg-chariot-stroke-cyan/10 text-chariot-stroke-cyan',
  },
  export: {
    label: 'Export',
    className: 'bg-chariot-stroke-blue/10 text-chariot-stroke-blue',
  },
  internal: {
    label: 'Internal',
    className: 'bg-chariot-stroke-magenta/10 text-chariot-stroke-magenta',
  },
};

export type FileVisibility = 'private' | 'public';

// `internal` files are Praetorian-only, so they're Private; every other source
// (shared-with/by, report, loa, export) is customer-visible, hence Public. An
// undefined source only happens on untagged rows, which are never internal —
// so default to Public.
export const getFileVisibility = (
  source: DocumentSource | undefined
): FileVisibility => (source === 'internal' ? 'private' : 'public');

export const VISIBILITY_BADGE_CONFIG: Record<
  FileVisibility,
  { label: string; className: string }
> = {
  private: {
    label: 'Private',
    className: 'bg-chariot-stroke text-chariot-text-primary',
  },
  public: {
    label: 'Public',
    className: 'bg-chariot-stroke-light-blue/10 text-chariot-stroke-light-blue',
  },
};
